import React from 'react';
import { GoogleMap, useJsApiLoader, OverlayView } from '@react-google-maps/api';

const centro = { lat: -33.5, lng: -65.0 };
const libraries = ['places'];

const coloresTipo = {
  mantenimiento: { bg: '#f97316', dark: '#c2410c' },
  reparacion:    { bg: '#ef4444', dark: '#b91c1c' },
  inspeccion:    { bg: '#3b82f6', dark: '#1d4ed8' },
  instalacion:   { bg: '#22c55e', dark: '#15803d' },
};

const iconosEstado = {
  pendiente:     '⏳',
  'en progreso': '🔄',
  finalizado:    '✅',
};

function MarkerCustom({ trabajo, onClick }) {
  const color = coloresTipo[trabajo.tipo] || { bg: '#888', dark: '#555' };
  const icono = iconosEstado[trabajo.estado] || '📍';

  return (
    <OverlayView
      position={{ lat: trabajo.latitud, lng: trabajo.longitud }}
      mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
    >
      <div
        onClick={onClick}
        title={`${trabajo.titulo} — ${trabajo.estado}`}
        style={{
          cursor: 'pointer',
          transform: 'translate(-50%, -100%)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          filter: 'drop-shadow(0px 3px 4px rgba(0,0,0,0.35))',
          transition: 'transform 0.15s',
        }}
        onMouseEnter={e => e.currentTarget.style.transform = 'translate(-50%, -100%) scale(1.2)'}
        onMouseLeave={e => e.currentTarget.style.transform = 'translate(-50%, -100%) scale(1)'}
      >
        <div style={{ position: 'relative' }}>
          <svg width="32" height="40" viewBox="0 0 32 40" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M16 2C9.373 2 4 7.373 4 14C4 22.5 16 38 16 38C16 38 28 22.5 28 14C28 7.373 22.627 2 16 2Z"
              fill={color.bg}
              stroke={color.dark}
              strokeWidth="1.5"
            />
            <circle cx="16" cy="14" r="5.5" fill="white" fillOpacity="0.95"/>
            <circle cx="16" cy="14" r="3" fill={color.dark}/>
          </svg>
          <div style={{
            position: 'absolute',
            top: '-8px',
            right: '-8px',
            fontSize: '12px',
            lineHeight: 1,
            background: 'white',
            borderRadius: '50%',
            width: '16px',
            height: '16px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
          }}>
            {icono}
          </div>
        </div>
      </div>
    </OverlayView>
  );
}

function Mapa({ trabajos, onSeleccionar }) {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_KEY || '',
    libraries,
    language: 'es',
    region: 'AR'
  });

  if (!isLoaded) return <div className="mapa-cargando">Cargando mapa...</div>;

  return (
    <GoogleMap
      mapContainerClassName="mapa"
      center={centro}
      zoom={6}
      options={{
        styles: [
          { featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'off' }] }
        ],
        zoomControl: true,
      }}
    >
      {trabajos.map(trabajo => (
        <MarkerCustom
          key={trabajo.id}
          trabajo={trabajo}
          onClick={() => onSeleccionar(trabajo)}
        />
      ))}
    </GoogleMap>
  );
}

export default Mapa;